module.exports = __webpack_public_path__ + "static/media/app-store.b51d9767.png";